import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActionsService } from '../../../api/actions.service';
import { StorageService } from '../../../services/storage.service';
import { ClientActionService } from '../../../services/client-action.service';
import clean from 'lodash-clean';
import { environment } from '../../../../environments/environment';
import { RegistrationStep } from '../../../funnel/registration-step';
import { VALIDATION_ERRORS_MESSAGE } from '../../../constants/validation-errors.const';
import { FORM_MASK } from '../../../constants/form-masks.const';
import { AnalyticsEventsService } from '../../../services/analytic.service';
import { ValidationService } from '../../../components/form-fields/validation.service';
import { deleteTrailingSpaces } from '../../../utils/delete-extra-characters';
import { focusToNextRow } from '../../../utils/focus-to-next-row';
import validateAllFormFields from '../../../utils/validate-all-form-fields';
import setDateFormat from '../../../utils/set-date-format';
import getTitle from '../../../utils/get-title';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { CardInformationPopupComponent } from '../../successful-scoring-result/card-information-popup/card-information-popup.component';
import detectMobile from 'src/app/utils/detect-mobile';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { DuplicationService } from '../../../services/duplication.service';
import { ConfirmationSmsComponent } from '../../confirmation-sms/confirmation-sms.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { timeout } from 'rxjs/operators';
import { RegistrationService } from '../../../services/registration.service';
import { RegistrationLinksConst } from '../../../constants/registration-links.const';
import * as moment from 'moment-mini-ts';
import {
  ConfigParamsEnum,
  ConfigValuesEnum,
} from '../../../constants/config.enum';
import { TidService } from '../../../services/tid.service';
import { TidRegistrationStep } from '../../tid/tid.interface';
import { Subscription } from 'rxjs';

declare var actionClickNextPage: any;

@Component({
  selector: 'app-first-registration-step',
  templateUrl: './first-registration-step.component.html',
  styleUrls: ['./first-registration-step.component.sass'],
  providers: [StorageService],
})
export class FirstRegistrationStepComponent
  extends RegistrationStep
  implements OnInit, OnDestroy
{
  public brand: string;
  public registrationForm: FormGroup;
  public partnersAgreements: FormGroup;
  public registrationInfo = { source: 'SITE' };
  public regInfoId;
  private configParams = ConfigParamsEnum;
  private configValues = ConfigValuesEnum;

  private esiaVerified = true;

  public agreementAdvtFlag = false;
  public tidError = false;

  public mainPhone;

  @ViewChild(CardInformationPopupComponent)
  public cardPopup: CardInformationPopupComponent;

  public deleteSpaces: any;
  public nextRowFocus: any;

  private sub: Subscription = new Subscription();
  public browser;

  public isButtonDisable = false;
  public confirmation = false;

  public isMobile = false;

  public esiaPath: string;
  public esiaAuth = false;
  public esiaErrorMessage: string;

  public formId;
  public ERRORS_MESSAGE;
  public MASK;
  public esiaAvailabilityStatus: boolean;
  public documentLinks;

  private resendConfirmationListener = new EventEmitter<boolean>();

  private confirmationDialog: DynamicDialogRef;

  public result;

  constructor(
    public fb: FormBuilder,
    private actionsService: ActionsService,
    public storageService: StorageService,
    public clientActionService: ClientActionService,
    public analyticService: AnalyticsEventsService,
    private titleService: Title,
    private _route: ActivatedRoute,
    private _registrationService: RegistrationService,
    private location: Location,
    private recaptchaV3Service: ReCaptchaV3Service,
    private duplicationService: DuplicationService,
    private dialogService: DialogService,
    private _tid: TidService
  ) {
    super(RegistrationStep.FIRST_STEP);

    this.ERRORS_MESSAGE = VALIDATION_ERRORS_MESSAGE;
    this.MASK = FORM_MASK;
    // модель формы
    this.registrationForm = fb.group({
      requestedLoan: fb.group({
        amount: [''],
        duration: [''],
      }),
      firstName: [
        '',
        [
          Validators.required,
          ValidationService.language,
          Validators.maxLength(255),
        ],
      ],
      lastName: [
        '',
        [
          Validators.required,
          ValidationService.language,
          Validators.maxLength(255),
        ],
      ],
      middleName: ['', [ValidationService.language, Validators.maxLength(255)]],
      gender: ['', Validators.required],
      mainPhone: [
        '',
        [
          Validators.required,
          ValidationService.phonelength,
          ValidationService.nonexistentphone,
        ],
      ],
      email: [
        '',
        [
          Validators.required,
          ValidationService.emailFormat,
          ValidationService.emailSpace,
          Validators.maxLength(255),
        ],
      ],
      rulesAccepted: [false, ValidationService.requiredtrue],
      agreements: fb.group({
        agreement1: [false, ValidationService.requiredtrue],
        agreement2: [false, ValidationService.requiredtrue],
        agreement3: [false, ValidationService.requiredtrue],
        agreement4: [false, ValidationService.requiredtrue],
        agreement5: [false, ValidationService.requiredtrue],
        agreement6: [false, ValidationService.requiredtrue],
        agreement7: [false, ValidationService.requiredtrue],
        agreement8: [false, ValidationService.requiredtrue],
        agreement9: [false],
        agreement10: [false, ValidationService.requiredtrue],
      }),

      infoComplaint: [true],
      brand: [this.brand],
    });

    this.partnersAgreements = fb.group({
      partnersAgreement1: [true, ValidationService.requiredtrue],
      partnersAgreement2: [true, ValidationService.requiredtrue],
      partnersAgreement3: [true, ValidationService.requiredtrue],
      partnersAgreement4: [true, ValidationService.requiredtrue],
      partnersAgreement5: [true, ValidationService.requiredtrue],
      partnersAgreement6: [true, ValidationService.requiredtrue],
      partnersAgreement7: [true, ValidationService.requiredtrue],
      partnersAgreement8: [true, ValidationService.requiredtrue],
      partnersAgreement9: [true, ValidationService.requiredtrue],
      partnersAgreement10: [true, ValidationService.requiredtrue],
      partnersAgreement11: [true, ValidationService.requiredtrue],
      partnersAgreement12: [true, ValidationService.requiredtrue],
    });

    this.registrationForm.get('rulesAccepted').valueChanges.subscribe((v) => {
      if (v) this.setAllAgreementsToTrue();
    });

    this.registrationForm.get('agreements').valueChanges.subscribe((_) => {
      if (
        !this.registrationForm.get('agreements').valid &&
        this.registrationForm.get('rulesAccepted').value
      )
        this.registrationForm.get('rulesAccepted').setValue(false);
    });

    this.partnersAgreements.valueChanges.subscribe((_) => {
      this.registrationForm
        .get('agreements.agreement10')
        .setValue(this.partnersAgreements.valid);
    });

    this.deleteSpaces = deleteTrailingSpaces;
    this.nextRowFocus = focusToNextRow;

    // Слушатель переотправки кода. Переотправляем форму, если код запрошен по новой
    this.sub.add(
      this.resendConfirmationListener.subscribe((_) => {
        this.resendConfirmationCode();
      })
    );
  }

  public get registrationValid() {
    if (this.registrationForm.valid) {
      return 'valid-result--none';
    } else if (!this.registrationForm.valid) {
      return 'valid-result';
    }
  }

  esiaEventMetrika() {
    this.analyticService.esiaClickFirstStep();
  }

  ngOnInit() {
    super.ngOnInit();
    this.brand = environment.brand;
    this.documentLinks = RegistrationLinksConst[environment.brand];

    this.esiaPath = `${environment.apiUrl}/esia?brand=${
      this.brand
    }&redirectUri=${encodeURIComponent(window.location.href)}`;

    this.actionsService.getEsiaAvailabilityStatus(this.brand).then((res) => {
      this.esiaAvailabilityStatus = res.data;
      const { regInfoId, error } = this._route.snapshot.queryParams;
      this.esiaAuth = !!regInfoId;
      console.log(this.esiaAuth);

      this.esiaErrorMessage =
        this._registrationService.getEsiaErrorMessage(error);

      if (error) this.location.replaceState('/1');
    });

    //получение данных от партнера
    if (window.location.href.includes('phone')) {
      let { last_name, first_name, patronymic, phone, email } =
        this._route.snapshot.queryParams;

      if (phone.length === 11) {
        phone = phone.slice(1);
      }

      this.registrationForm.patchValue({
        lastName: last_name,
        firstName: first_name,
        middleName: patronymic,
        mainPhone: phone,
        email: email,
      });
    }

    this._registrationService.registrationInfo.subscribe(({ data }) => {
      if (!data) {
        return;
      }
      const {
        lastName,
        firstName,
        middleName,
        esiaVerified,
        id,
        mainPhone,
        gender,
        email,
        currentStage,
      } = data.form;

      this.stepNumber = 1;
      this.formId = id;

      if (esiaVerified) {
        this.regInfoId = data.id;
        ['lastName', 'middleName', 'firstName'].forEach((e) => {
          this.registrationForm.get(e).disable();
          this.registrationForm.get(e).markAsTouched();
          this.registrationForm.get(e).markAsDirty();
        });

        this.registrationForm.patchValue({
          lastName: lastName,
          firstName: firstName,
          middleName: middleName,
        });
      }

      this.mainPhone = mainPhone;
      this.formId = id;
      setDateFormat(this.registrationForm, data.form);

      if (currentStage === 1) {
        this.stepNumber = 2;
        this.registrationForm.patchValue({
          lastName: lastName,
          firstName: firstName,
          middleName: middleName,
          mainPhone,
          gender,
          email,
        });
        this.showConfirmationWindow(data.id);
        return;
      }
    });

    this.sub.add(
      this.actionsService
        .getApiConfig(this.configParams.AGREEMENTS, this.configParams.TID)
        .subscribe((v) => {
          this.openAgreementsByConfig(v[this.configParams.AGREEMENTS]);

          if (v[this.configParams.TID] && !this.esiaAuth) {
            this.runTIDRegistrationFlow();
          }
        })
    );

    /**
     *  ------------- app query params -------------
     * amount - query param for the requestedLoan
     * duration qery param for tje requesteLoan
     */
    const { amount, duration } = this._route.snapshot.queryParams;

    if (amount) {
      this.registrationForm.get('requestedLoan.amount').setValue(amount);
    } else {
      this.registrationForm.get('requestedLoan.amount').setValue('30000');
    }

    if (duration) {
      this.registrationForm.get('requestedLoan.duration').setValue(duration);
    } else {
      this.registrationForm.get('requestedLoan.duration').setValue('84');
    }

    this.titleService.setTitle(getTitle(this.brand, 'FIRST_REG_STEP'));

    this.isMobile = detectMobile();

    this.registrationInfo['referrer'] = document.referrer;
    this.analyticService.setMatomo('Registration Initial Info');

    this.getBrowserInfo();
    this.browser = document.getElementsByTagName('BODY')[0].classList;
    this.registrationInfo['queryString'] = window.location.search.slice(1);

    this.analyticService.eventYandexMetrica('load_page_first_step_reg')
  }

  public eventAnalytic(): void {
    this.analyticService.eventYandexMetrica('click_reg_esia')
  }

  /**
   * Регистрация через TID
   * @private
   */
  private runTIDRegistrationFlow() {
    this._tid.initiateDefaultRegistrationButton(this.brand);

    this._tid.activeRegistrationProcess.subscribe({
      next: (value) => {
        if (value?.client !== undefined) {
          const { email, phone, lastName, firstName, middleName, gender } =
            value.client;

          this.registrationForm.patchValue({
            lastName: lastName,
            firstName: firstName,
            middleName: middleName,
            email: email,
            gender: gender,
            mainPhone: phone.slice(2),
          });
          ['lastName', 'firstName', 'middleName', 'email', 'gender', 'mainPhone']
            .forEach((e) => {
              if (this.registrationForm.get(e).value) {
                this.registrationForm.get(e).disable();
                this.registrationForm.get(e).markAsTouched();
                this.registrationForm.get(e).markAsDirty();
              }
          });
          this.mainPhone = phone;
        }
      },
      error: () => {
        this.tidError = true;
      },
    });
    this._tid.fillRegistrationData();
  }

  public get agreementsGroup(): FormGroup {
    return this.registrationForm.get('agreements') as FormGroup;
  }

  public setAllAgreementsToTrue() {
    this.registrationForm.get('agreements').patchValue({
      agreement1: true,
      agreement2: true,
      agreement3: true,
      agreement4: true,
      agreement5: true,
      agreement6: true,
      agreement7: true,
      agreement8: true,
      agreement9: true,
      agreement10: true,
    });

    this.setPartnersAgreementToTrue();
  }

  public setPartnersAgreementToTrue() {
    this.partnersAgreements.patchValue({
      partnersAgreement1: true,
      partnersAgreement2: true,
      partnersAgreement3: true,
      partnersAgreement4: true,
      partnersAgreement5: true,
      partnersAgreement6: true,
      partnersAgreement7: true,
      partnersAgreement8: true,
      partnersAgreement9: true,
      partnersAgreement10: true,
      partnersAgreement11: true,
      partnersAgreement12: true,
    });
  }

  /**
   * Проверка
   * @param config :string
   * @private
   */
  private openAgreementsByConfig(config: string) {
    const { AGREEMENTS_OPEN, AGREEMENTS_CLOSE, AGREEMENTS_BY_TIME } =
      this.configValues;
    switch (config) {
      case AGREEMENTS_OPEN:
        this.agreementAdvtFlag = true;
        break;
      case AGREEMENTS_CLOSE:
        this.agreementAdvtFlag = false;
        break;
      case AGREEMENTS_BY_TIME:
        this.checkAgreementsOpenByTime();
        break;
      default:
        this.agreementAdvtFlag = false;
        break;
    }
  }

  /**
   * Проверка отображения открытого списка согласий
   * по времени
   * @private
   */
  private checkAgreementsOpenByTime() {
    const hour = moment().utcOffset(3).get('hour');

    if ((hour >= 5 && hour < 7) || (hour >= 21 && hour < 23)) {
      this.agreementAdvtFlag = true;
    }
  }

  public showAdditionalAgreements() {
    this.agreementAdvtFlag = !this.agreementAdvtFlag;
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  validateRegistrationFields() {
    validateAllFormFields(this.registrationForm).then((res) => {
      // When invalid fields are received, they are sent to the Analytics
      res.forEach((key) =>
        this.analyticService.registrationError(
          'registration_error_API',
          key,
          'поле обязательно для заполнения'
        )
      );
    });
  }

  public sendWithCaptcha(value): void {
    this.isButtonDisable = true;
    let tokenStr;
    this.recaptchaV3Service
      .execute('sendCodeLogin')
      .pipe(timeout(30000))
      .subscribe({
        next: (token: string) => {
          tokenStr = token;
        },
        error: (err: string) => {
          this.submitForm(value, null);
        },
        complete: () => {
          this.submitForm(value, tokenStr);
        },
      });
  }

  /**
   * Method of submitting registration form
   * @param {FirstStep} value
   * @param tokenStr
   */
  submitForm(value, tokenStr): void {
    value = this.registrationForm.getRawValue();

    value.firstName = value.firstName.value || value.firstName;
    value.lastName = value.lastName.value || value.lastName;
    value.middleName = value.middleName.value || value.middleName;
    value.agreementAdvt = value.agreements.agreement9;

    // при отправке формы ищем все невалидные поля
    this.validateRegistrationFields();

    if (this.registrationForm.valid) {
      this.analyticService.sendGTMDataLayerEvent('reg_first_step_submit', {
        formValid: true,
      });
      // преобразуме данные в необходимый формат
      value.mainPhone = this.clientActionService.changePhoneFormat(
        value.mainPhone
      );

      // удаляем все пустые поля из формы
      const formData = clean(value);

      formData['currentStage'] = this.stepNumber;

      this.registrationInfo['form'] = formData;

      if (this.regInfoId) this.registrationInfo['id'] = this.regInfoId;

      this.sub.add(
        this.actionsService
          .sendRegistrationForm(
            this.registrationInfo,
            this.stepNumber,
            tokenStr
          )
          .subscribe({
            next: ({ data }) => {
              this.formId = data.response.form.id;
              this.mainPhone = data.response.form.mainPhone;

              this.confirmation = this.duplicationService.checkConfirmationCode(
                this.registrationForm.value.mainPhone,
                data.handlers
              );

              if (this.confirmation) {
                this.showConfirmationWindow(data.response.id);
                this.isButtonDisable = false;
              }

              //TODO: Упростить до одного вызова
              this.analyticService.firstStep();
              this.analyticService.sendDataClient(value.mainPhone);
            },
            error: (_) => {
              this.analyticService.sendGTMDataLayerEvent('reg_unknown_error');
            },
          })
      );
    } else {
      this.isButtonDisable = false;
      this.analyticService.eventYandexMetrica('not_valid_first_step');
    }
    actionClickNextPage(1);
  }

  private resendConfirmationCode() {
    this.sendWithCaptcha(this.registrationForm);
  }

  private showConfirmationWindow(regInfoId: string) {
    if (this.confirmationDialog) this.confirmationDialog.destroy();

    this.confirmationDialog = this.dialogService.open(
      ConfirmationSmsComponent,
      {
        data: {
          formId: this.formId,
          phoneNumber: this.mainPhone,
          brand: this.brand,
          resendConfirmationCode: this.resendConfirmationListener,
        },
        closable: false,
      }
    );

    this.confirmationDialog.onClose.subscribe((v) => {
      this.isButtonDisable = false;
      actionClickNextPage(2, regInfoId);
    });
  }

  getBrowserInfo() {
    this.registrationInfo['userAgent'] = window.navigator.userAgent;
  }

  /**
   * Страница с правилами
   * @param {event: Event}
   */
  public get rulesLink() {
    return `https://${this.brand.toLowerCase()}.ru/rules`;
  }
}
